import PropTypes from "prop-types";
import styled from "styled-components";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "react-tooltip";
import { dh_colors } from "theme";

const StyledPill = styled.div`
  font-family: Inter;
  text-align: center;
  width: fit-content;
  background-color: #dadde1;
  color: #000000;
  display: flex;
  align-items: center;

  ${(props) =>
    props.size === "small" &&
    `
    font-size: 12px;
    padding: 2px 12px;
    border-radius: 10px;
    min-height: 20px;

    `}

  ${(props) =>
    props.size === "large" &&
    `
    font-size: 18px;
    padding: 4px 15px;
    border-radius: 16px;

  `}

  ${(props) =>
    props.variant === "info" &&
    `
    background-color: #007EAC;
    color: #FFFFFF;
  `}

  ${(props) =>
    props.variant === "pending" &&
    `
    background-color: #5F6467;
    color: #FFFFFF;
  `}

  ${(props) =>
    props.variant === "warning" &&
    `
    background-color: #D68712;
    color: #FFFFFF;
  `}

  ${(props) =>
    props.variant === "failed" &&
    `
    background-color: var(--error);
    color: #FFFFFF;
  `}

  ${(props) =>
    props.variant === "success" &&
    `
    background-color: ${dh_colors.status_success_50};
    color: #FFFFFF;
  `}

    ${(props) =>
    props.variant === "operator" &&
    `
    background-color: ${dh_colors.grey_90};
    color: ${dh_colors.white};
  `}

  ${(props) =>
    props.hasTooltip &&
    `
    & > div {
      display: flex;
      align-items: center;

      & > div {
        display: flex;
        align-items: center;
        position: relative;
      }

      svg {
        margin-left: 7px;
        cursor: pointer;
      }
    }
  `}

  .tooltip-arrow {
    display: none;
  }
`;

const Pill = ({
  text = "",
  children,
  size = "small",
  variant = "default",
  tooltipId = "",
  tooltipContent = "",
  textDataTest = "",
  tooltipStrategy = "absolute",
  tooltipPlacement = "bottom-end",
}) => {
  return (
    <StyledPill size={size} variant={variant} hasTooltip={!!tooltipContent}>
      {tooltipContent ? (
        <div>
          <div data-test={textDataTest}>{children ?? text}</div>
          <div>
            <FontAwesomeIcon
              data-tooltip-id={tooltipId}
              icon={faCircleInfo}
              style={{
                width: "16px",
                height: "16px",
                boxSizing: "border-box",
              }}
            />
          </div>
        </div>
      ) : (
        <span data-test={textDataTest}>{children ?? text}</span>
      )}
      <Tooltip
        // isOpen={true}
        id={tooltipId}
        style={{ zIndex: 100000, maxWidth: "400px" }}
        positionStrategy={tooltipStrategy}
        place={tooltipPlacement}
        clickable={true}
        classNameArrow="tooltip-arrow"
        offset={8}
      >
        {tooltipContent}
      </Tooltip>
    </StyledPill>
  );
};

Pill.propTypes = {
  text: PropTypes.string,
  variant: PropTypes.oneOf([
    "default",
    "info",
    "pending",
    "warning",
    "failed",
    "success",
    "pending",
  ]),
  size: PropTypes.oneOf(["small", "large"]),
  tooltipContent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default Pill;
